import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ShopCategoriesType } from '../../../../types/shopCategories';
import { InputTitle } from '../../../atoms';
import { SHOP_CATEGORIES } from '../../../../constants/define/translation';

interface ColumnProps {
  record: ShopCategoriesType;
  handleChangeInputTitle: Function;
  onFocusNewRow: Function;
}

export default React.memo((props: ColumnProps) => {
  const { t } = useTranslation(SHOP_CATEGORIES);
  const { record, handleChangeInputTitle, onFocusNewRow } = props;
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({ title: record?.title });
  }, [record]);

  const onChangeInput = (e: any) => {
    form.setFieldsValue({ title: e.target.value });
    handleChangeInputTitle(record.index, e.target.value);
  };

  return (
    <StyledInputTitleContainer>
      <Form form={form} name={`form_input_title_category_${record.index}`} autoComplete="off">
        <Form.Item name="title" rules={[{ required: true, message: t('validate.titleBlank') }]}>
          <InputTitle record={record} onChangeInput={onChangeInput} onFocusNewRow={onFocusNewRow} />
        </Form.Item>
      </Form>
    </StyledInputTitleContainer>
  );
});

const StyledInputTitleContainer = styled.div`
  display: flex;
  align-items: center;
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .box {
    font-weight: 600;
    overflow-wrap: anywhere;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`;
